module.exports = __webpack_public_path__ + "static/media/Camada_7.01cf1b1a.svg";